<template>
    <div class="download-app">
	<div class="container">
		<div class="row">
			<div class="col-md-6">
				<div class="download-option">
					<h3>Send money in an instant while you’re on the go</h3>
					<div class="download-buttons">
						<button type="button" @click="location('https://play.google.com/store/apps/details?id=com.app.mtaeremit&hl=en')" class="download-btn">
							<img src="/static/commercial/img/icons/android.png" alt="">
							<p>Get it for<br><span>Android</span></p>
						</button>
						<button type="button" @click="location('https://itunes.apple.com/us/app/e-remit/id1060407677?mt=8')" class="download-btn">
							<img src="/static/commercial/img/icons/ios.png" alt="">
							<p>Get it for<br><span>App Store</span></p>
						</button>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="mobile-image">
					<img src="/static/commercial/img/newsletter.png" alt="">
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: "DownloadApp",  
  created() {},

  methods: {
    location: function (href) {

		//window.location.href = href;
		window.open(href,"_blank");
    }
  }
};
</script>
